import { render, staticRenderFns } from "./AddEditPermission.vue?vue&type=template&id=c995db1e&scoped=true"
import script from "./AddEditPermission.vue?vue&type=script&lang=js"
export * from "./AddEditPermission.vue?vue&type=script&lang=js"
import style0 from "./AddEditPermission.vue?vue&type=style&index=0&id=c995db1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c995db1e",
  null
  
)

export default component.exports